var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.842 22.214.928-.928a.56.56 0 0 0 0-.796L9.3 12l8.47-8.49a.56.56 0 0 0 0-.796l-.928-.928a.563.563 0 0 0-.796 0L6.23 11.602a.563.563 0 0 0 0 .796l9.816 9.816c.22.22.576.22.796 0"
  })));
};
export default SvgChevronLeft;